import * as React from 'react';
import { useEffect } from 'react';

import TranscriptHighlightButton from 'bundles/interactive-transcript/components/TranscriptHighlightButton';

import _t from 'i18n!nls/interactive-transcript';

const SAVE_CONFIRMATION_TIMEOUT_MILLISECONDS = 800;

type Props = {
  cueIndex?: number;
  onTimeoutReached: () => void; // This is a bit unusual, but allows the timeout code to be here rather than in the parent, to minimize logic related to showing a temporary popup in the parent.
};

const SaveHighlightConfirmationPopup: React.VFC<Props> = ({ cueIndex, onTimeoutReached }) => {
  useEffect(() => {
    const timerId = setTimeout(onTimeoutReached, SAVE_CONFIRMATION_TIMEOUT_MILLISECONDS);
    // Clean up if we unmount before the timer ends:
    return () => clearTimeout(timerId);
  }, [cueIndex, onTimeoutReached]);

  if (!cueIndex && cueIndex !== 0) {
    return null;
  }

  return (
    <TranscriptHighlightButton
      cueIndex={cueIndex}
      label={_t('Note saved!')}
      trackingName="transcript_highlight_saved_popup"
      onClick={() => {
        onTimeoutReached();
      }}
    />
  );
};

export default SaveHighlightConfirmationPopup;
